export default function authHeader() {
    const userStr = localStorage.getItem("user");
  
    let user = null;
    if (userStr)
      user = JSON.parse(userStr);
  
    if (user && user.accessToken) {
      return { "Content-Type" : "application/json", Authorization: 'Bearer ' + user.accessToken, RefreshT: 'Bearer ' + user.refreshToken }; // for Spring Boot back-end
      // return { 'x-access-token': user.accessToken };       // for Node.js Express back-end
    } else {
      return { "Content-Type" : "application/json", Authorization: '' }; // for Spring Boot back-end
      // return { 'x-access-token': null }; // for Node Express back-end
    }
    
  }
  
  